"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationTodo',
  data: function data() {
    return {
      loading: false,
      rebuilding: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        taskType: '',
        status: 'open',
        roleCode: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      summary: {
        total: 0,
        byTaskType: {}
      },
      taskTypes: [{
        value: 'pay',
        label: '待支付'
      }, {
        value: 'sign',
        label: '待签字'
      }, {
        value: 'purchase',
        label: '待采购'
      }, {
        value: 'receipt',
        label: '待签收'
      }, {
        value: 'rectify',
        label: '待整改'
      }, {
        value: 'service',
        label: '待服务'
      }, {
        value: 'review',
        label: '待挽回'
      }, {
        value: 'complaint',
        label: '待投诉'
      }, {
        value: 'campaign',
        label: '待投放'
      }, {
        value: 'referral',
        label: '待推荐'
      }, {
        value: 'staff',
        label: '待激活'
      }, {
        value: 'content',
        label: '待发布'
      }, {
        value: 'package',
        label: '待套餐'
      }],
      roles: [{
        value: 'owner',
        label: '负责人'
      }, {
        value: 'business',
        label: '业务'
      }, {
        value: 'material',
        label: '材料员'
      }, {
        value: 'foreman',
        label: '工长'
      }, {
        value: 'supervisor',
        label: '监理'
      }, {
        value: 'owner_customer',
        label: '业主'
      }, {
        value: 'owner_supervisor',
        label: '业主监理'
      }],
      typeTag: {
        pay: 'warning',
        sign: '',
        purchase: 'success',
        receipt: 'info',
        rectify: 'danger',
        service: ''
      },
      statusTag: {
        open: 'warning',
        done: 'success',
        cancelled: 'info'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    typeText: function typeText(value) {
      return {
        pay: '待支付',
        sign: '待签字',
        purchase: '待采购',
        receipt: '待签收',
        rectify: '待整改',
        service: '待服务',
        review: '待挽回',
        complaint: '待投诉',
        campaign: '待投放',
        referral: '待推荐',
        staff: '待激活',
        content: '待发布',
        package: '待套餐'
      }[value] || value;
    },
    statusText: function statusText(value) {
      return {
        open: '待处理',
        done: '已完成',
        cancelled: '已取消'
      }[value] || value;
    },
    roleText: function roleText(value) {
      var found = this.roles.find(function (item) {
        return item.value === value;
      });
      return found ? found.label : value;
    },
    typeCount: function typeCount(value) {
      return Number(this.summary.byTaskType && this.summary.byTaskType[value] || 0);
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      Promise.all([(0, _decoration.decorationTodoListApi)(this.searchForm), (0, _decoration.decorationTodoSummaryApi)({
        taskType: this.searchForm.taskType,
        status: this.searchForm.status,
        roleCode: this.searchForm.roleCode
      })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          list = _ref2[0],
          summary = _ref2[1];
        _this.tableData.data = list.list || [];
        _this.tableData.total = list.total || 0;
        _this.summary = summary || {
          total: 0,
          byTaskType: {}
        };
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        taskType: '',
        status: 'open',
        roleCode: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    rebuild: function rebuild() {
      var _this2 = this;
      this.rebuilding = true;
      (0, _decoration.decorationTodoRebuildApi)().then(function (count) {
        _this2.$message.success("\u5DF2\u91CD\u5EFA ".concat(count || 0, " \u6761\u5F85\u529E\u6295\u5F71"));
        _this2.getList();
      }).catch(function (error) {
        _this2.$message.error(error && error.message || '重建失败');
      }).finally(function () {
        _this2.rebuilding = false;
      });
    }
  }
};